// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"d25bf0fd","272":"a6988b9a","347":"ee3a9516","605":"d912b97f","884":"bb54bc46","897":"3db2aad8","901":"a91c7379","966":"795396a9","993":"34ab17ba"}[chunkId] + ".chunk.js";
};